import { render, staticRenderFns } from "./PrestationCancelledReplaceWithprovision.vue?vue&type=template&id=756098e8"
import script from "./PrestationCancelledReplaceWithprovision.vue?vue&type=script&lang=js"
export * from "./PrestationCancelledReplaceWithprovision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports